// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W6xp9C {
  display: inline-flex;
  align-items: stretch;
  gap: 10px;
  padding: 4px 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface-2);
}

.oPrYAb {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 32px;
}

.oPrYAb + .oPrYAb {
  padding-left: 10px;
  border-left: 1px solid var(--border);
}

.MydIu0 {
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--text-muted);
  font-weight: 600;
}

.qQHWeA {
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  color: var(--text);
}
`, "",{"version":3,"sources":["webpack://./app/src/components/TimeBox.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qEAAqE;EACrE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".timeBox {\n  display: inline-flex;\n  align-items: stretch;\n  gap: 10px;\n  padding: 4px 10px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--surface-2);\n}\n\n.timeBoxColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  min-width: 32px;\n}\n\n.timeBoxColumn + .timeBoxColumn {\n  padding-left: 10px;\n  border-left: 1px solid var(--border);\n}\n\n.timeBoxLabel {\n  font-size: 10px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.timeBoxValue {\n  font-variant-numeric: tabular-nums;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 13px;\n  color: var(--text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timeBox": `W6xp9C`,
	"timeBoxColumn": `oPrYAb`,
	"timeBoxLabel": `MydIu0`,
	"timeBoxValue": `qQHWeA`
};
export default ___CSS_LOADER_EXPORT___;
